import { Select } from 'antd'
import moment from 'moment'
import { API } from 'admin/lib/Api/core'
import { COUNTRY } from '@qflow/constants'

function clearLoadedData(state: any) {
  API.Abort()
  return {
    ...state,
    recordsLoaded: [],
    pagesLoaded: 1,
    continuationToken: null
  }
}

export function reducer(
  state: { recordsLoaded: any; reloadRecords: number },
  action: {
    type: any
    data: {
      dates: moment.MomentInput[]
      accountIds: any
      projectIds: any
      statuses: any
      modules: any
      assignees: any
      countries: any
      companyName: any
      movementId: any
      templateNames: any
      recordsLoaded: any
      pagesLoaded: any
      continuationToken: any
    }
  }
) {
  switch (action.type) {
    case 'setDateRange':
      if (!action.data.dates) {
        return {
          ...clearLoadedData(state),
          startDate: moment().subtract(14, 'd').startOf('day').format(),
          endDate: moment().endOf('day').format()
        }
      }
      return {
        ...clearLoadedData(state),
        startDate: moment(action.data.dates[0]).format(),
        endDate: moment(action.data.dates[1]).format()
      }
    case 'setAccountFilter':
      return {
        ...clearLoadedData(state),
        accountIds: action.data.accountIds,
        projectIds: action.data.projectIds
      }
    case 'setProjectFilter':
      return { ...clearLoadedData(state), projectIds: action.data.projectIds }
    case 'setStatusFilter':
      return { ...clearLoadedData(state), statuses: action.data.statuses }
    case 'setModulesFilter':
      return { ...clearLoadedData(state), modules: action.data.modules }
    case 'setAssigneeFilter':
      return { ...clearLoadedData(state), assignees: action.data.assignees }
    case 'setCountriesFilter':
      return { ...clearLoadedData(state), countries: action.data.countries }
    case 'setCompanyNameFilter':
      return { ...clearLoadedData(state), companyName: action.data.companyName }
    case 'setMovementIdFilter':
      return { ...clearLoadedData(state), movementId: action.data.movementId }
    case 'setTemplateNamesFilter':
      return {
        ...clearLoadedData(state),
        templateNames: action.data.templateNames
      }
    case 'setPageChanges':
      return {
        ...state,
        recordsLoaded: [...state.recordsLoaded, ...action.data.recordsLoaded],
        pagesLoaded: action.data.pagesLoaded,
        continuationToken: action.data.continuationToken
      }
    case 'onRefreshClick':
      return {
        ...clearLoadedData(state),
        reloadRecords: state.reloadRecords + 1
      }
    default:
      throw new Error(JSON.stringify(action))
  }
}

const { Option } = Select

export const availableStatuses = [
  <Option key="New">New</Option>,
  <Option key="Failed">Failed</Option>,
  <Option key="Published">Published</Option>,
  <Option key="AutoPublished">AutoPublished</Option>,
  <Option key="Escalated">Escalated</Option>,
  <Option key="Void">Void</Option>,
  <Option key="Removed">Removed</Option>
]

export const availableCountries = [
  <Option key={COUNTRY.AUSTRALIA}>{COUNTRY.AUSTRALIA}</Option>,
  <Option key={COUNTRY.CANADA}>{COUNTRY.CANADA}</Option>,
  <Option key={COUNTRY.FRANCE}>{COUNTRY.FRANCE}</Option>,
  <Option key={COUNTRY.GERMANY}>{COUNTRY.GERMANY}</Option>,
  <Option key={COUNTRY.IRELAND}>{COUNTRY.IRELAND}</Option>,
  <Option key={COUNTRY.SWITZERLAND}>{COUNTRY.SWITZERLAND}</Option>,
  <Option key={COUNTRY.UK}>{COUNTRY.UK}</Option>,
  <Option key={COUNTRY.USA}>{COUNTRY.USA}</Option>
]

export const availableModules = [
  <Option key="Waste">Waste</Option>,
  <Option key="Delivery">Delivery</Option>
]
